// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.header {\n\t\tbackground-color: black;\n\t\tmargin-bottom: 1em;\n\t\tpadding: 1em;\n\t\tposition: sticky;\n\t\tz-index: 666;\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n}\n@keyframes slideInDown {\nfrom {\n\t\t\theight: 0;\n\t\t\tpadding: 0;\n}\nto {\n\t\t\theight: 100px;\n\t\t\tpadding: 1em;\n}\n}\n.header .govolt_logo_header {\n\t\twidth: 8em;\n\t\theight: auto;\n\t\tcursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
